/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheImpressionDto } from './FcbRechercheImpressionDto';
import {
    FcbRechercheImpressionDtoFromJSON,
    FcbRechercheImpressionDtoFromJSONTyped,
    FcbRechercheImpressionDtoToJSON,
} from './FcbRechercheImpressionDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheImpressionDtoPaginatedResults
 */
export interface FcbRechercheImpressionDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheImpressionDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheImpressionDto>}
     * @memberof FcbRechercheImpressionDtoPaginatedResults
     */
    results?: Array<FcbRechercheImpressionDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheImpressionDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheImpressionDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheImpressionDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheImpressionDtoPaginatedResultsFromJSON(json: any): FcbRechercheImpressionDtoPaginatedResults {
    return FcbRechercheImpressionDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheImpressionDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheImpressionDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheImpressionDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheImpressionDtoPaginatedResultsToJSON(value?: FcbRechercheImpressionDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheImpressionDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

